import './DrillEventPanel.scss';

import Control from "../../1. Core/Control";
import TabControl from "../../1. Core/Controls/TabControl/TabControl";
import NP from "../../1. Core/NP";
import {EventTournament, IBattle, PageMode, VideoFile} from "../types";
import BattlesList from "../Library/Lists/BattlesList";
import Delegate from "../../1. Core/Delegate";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import {ServerAPI} from "../../1. Core/ServerAPI";
import EventVideoGeneratorDialog from "../../3. VideoEditor/EventVideoGeneratorDialog";
import MultiBattleVideoGeneratorDialog from "../../3. VideoEditor/MultiBattleVideoGeneratorDialog";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import Menu from '../../1. Core/Controls/Menu/Menu';
import {getCurrentUser} from "../../1. Core/UserInfo";
import ListItem from "../../1. Core/Controls/ListBox/ListItem";
import {showShareDialog} from "../../3. VideoEditor/func";
import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../1. Core/Controls/TextField/TextField";
import BattleVideoGeneratorDialog from "../../3. VideoEditor/BattleVideoGeneratorDialog";


export default class DrillEventPanel extends Control {

	_tabs: TabControl;

	_Event: EventTournament;

	private _Mode: null;
	private EvBackClick: Delegate;
	private _battleList: BattlesList;
	private _videoListNode: HTMLElement;
	private _topAppBar: TopAppBar;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvBackClick = new Delegate();
		this._Mode = null
		this._Event = null;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();


		this._topAppBar = new TopAppBar({
			ParentNode: this._root,
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: this._Event.Name,
			ShowSearchButton: false,
			EvBackClick: () => this.EvBackClick.fire(this)
		});
		this._topAppBar.setShowBackButton(true);


		if (getCurrentUser().isBDAdmin())
			this._topAppBar.addItem(new IconToggleButton({
				FontImage: NP.FontImages.add,
				Menu: new Menu({
					Items: [{
						Content: 'Video',
						Value: 'Video'
					}, {
						Content: 'Video by actions',
						Value: 'TopActions'
					}],
					EvItemSelected: (s, e) => this.createItemSelected(s, e)
				})
			}));

		let addVideoBtn = this._topAppBar.getRightItems()[1];
		if (addVideoBtn)
			addVideoBtn.hide()

		if (this._Mode == PageMode.mmahighlights || this._Mode == PageMode.kbhighlights)
			this._tabs = new TabControl({
				ParentNode: this._root,
				Items: [{
					Content: NP.RM.getString('Bouts'),
					Value: 'Bouts'
				}, {
					Content: 'Highlights',
					Value: 'Highlights'
				}],
				EvTabSelected: () =>
				{
					if (this._tabs.getValue() == "Bouts")
					{
						if (addVideoBtn)
							addVideoBtn.hide()
						NP.hide(this._videoListNode);
						this._battleList.show();
					}
					else
					{
						if (addVideoBtn)
							addVideoBtn.show()
						this._battleList.hide();
						NP.show(this._videoListNode);
						this.updateList()
					}
				}
			});

		this._battleList = new BattlesList({
			ParentNode: this._root,
			DrillDownFilter: {EventId: this._Event.Id, SortField: 'CreatedDate', HideStat: false, HideCancelled: false},
			Mode: this._Mode,
			Width: this._Width,
			Height: this.getTableHeight()
		});

		this._battleList.getTopAppBar().hide()

		this._battleList.setWidth(this.getWidth());
		this._battleList.setHeight(this.getHeight());
		this._battleList.refresh();

		this._videoListNode = NP.createNode(this._root, 'highlight-video-root');
		NP.hide(this._videoListNode)
	}

	async updateList()
	{
		this._root.querySelectorAll('.highlight-video-list').forEach(n => NP.removeFromParent(n))

		let files = await ServerAPI.get<VideoFile[]>(`/video/${this._Event.Id}`)

		if (files.length)
		{
			let n = NP.createNode(this._videoListNode, 'highlight-video-list');
			NP.createNode(n, 'video-list-header').innerText = 'Event videos'
			files.forEach(item => this.createVideoNode(n, item))
		}


		let battlesMap = {};
		let promises = [];
		for (let item of this._battleList.getBattles())
		{
			promises.push(ServerAPI.get<VideoFile[]>(`/video/battle-items/${item.Battle.Id}`).then(battleFiles =>
			{
				battlesMap[item.Battle.Id] = battleFiles;
			}))
		}

		await Promise.all(promises);

		for (let item of this._battleList.getBattles())
		{
			let listNode = NP.createNode(this._videoListNode, 'highlight-video-list');

			NP.createNode(listNode, 'video-list-separator')

			NP.createNode(listNode, 'video-list-header').innerText = `${item.RedName} vs ${item.BlueName}`;
			battlesMap[item.Battle.Id].forEach(item => this.createVideoNode(listNode, item))

			NP.createNode(listNode, 'video-list-add-item').addEventListener('click', () => this.addClickBtn(item.Battle))
		}
	}

	createVideoNode(parentNode: HTMLElement, item: VideoFile)
	{
		let node = NP.parseHTMLC(`<div class="highlight-video-item">
				<video controls preload="metadata">
				 	<source src="/video/${item.FileId}.mp4#t=7" type="video/mp4">
				</video>
				<span>
					${item.Name} 
					<br/>
					${item.Created}
				</span>
			</div>`)

		new IconToggleButton({
			FontImage: NP.FontImages.more_vert,
			ParentNode: node,
			Menu: new Menu({
				Items: [
					{RK: 'Share', EvClick: () => showShareDialog(item)},
					getCurrentUser().getIsAdmin() && {RK: 'Edit', EvClick: () => this.showRenameDialog(item)},
					getCurrentUser().getIsAdmin() && {IsSeparator: true},
					getCurrentUser().getIsAdmin() && {
						RK: 'Remove',
						EvClick: () =>
						{
							NP.showConfirm({
								RK: 'AreYouS',
								EvOkButtonClick: async () =>
								{
									await ServerAPI.delet(`/video/${item.FileId}`);
									NP.removeFromParent(node)
								}
							})
						}
					}
				]
			})
		});

		parentNode.appendChild(node)
	}

	addClickBtn(battle: IBattle)
	{
		(new BattleVideoGeneratorDialog({
			Battle: battle,
			EvClosed: () => this.updateList()
		})).show()
	}

	showRenameDialog(item: VideoFile)
	{
		let dlg = new Dialog({
			Content: new TextField({
				FloatingLabel: NP.RM.getString('Name'),
				Value: item.Name
			}),
			EvOkButtonClick: async () =>
			{
				item.Name = dlg.getContent().getValue();
				await ServerAPI.post(`/video/update-video-file`, item);
				this.updateList()
			}
		})

		dlg.show()
	}

	getTableHeight()
	{
		let value = this._Height
		if (this._tabs)
			value -= 44;

		return value - 64
	}

	setHeight(value: number)
	{
		super.setHeight(value);

		this._battleList.setHeight(this.getTableHeight());
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._battleList.setWidth(value);
	}

	createItemSelected(s: Menu, args: { Item: ListItem })
	{
		switch (args.Item.getValue())
		{
			case 'Video':
				(new EventVideoGeneratorDialog({
					Event: this._Event,
					EvClosed: () => this.updateList()
				})).show();
				break;
			case 'TopActions':
				(new MultiBattleVideoGeneratorDialog({
					Event: this._Event,
					EvClosed: () => this.updateList()
				})).show();
				break;
		}
	}
}
